import _ from 'lodash';
import ResourceListItem from './components/resource-list-item';

let postType = 'posts';

const Config = {
  /**
   * postType is the post type, duh.
   */
  postType,


  /**
   * appClass is the className that will be applied to the root component
   */
  appClass: 'blog-container',


  /**
   * elementId is the id of the element that will contain the app
   */
  elementId: 'blog-gallery',


  /**
   * searchPlaceholder is the placeholder text in the text search field
   */
  searchPlaceholder: 'Search Blog',


  /**
   * noResultsText is the text displayed when the filter gets back nothing
   */
  noResultsText: 'No Results Found. Please adjust your search terms.',

  /**
   * Ebook CTA displayed between post grids on filter
   */
  ebookContent: '',


  /**
   * pageLength is the number of items per "page"
   */
  pageLength: 6,


  /**
   * filterTaxonomies is used to set the order and label for the filters
   */
  filterTaxonomies: [{
    key: 'category',
    label: 'Categories'
  }],


  /**
   * itemView is the React Component used as the view for each item in the grid
   */
  itemView: ResourceListItem,


  /**
   * apiEndpoint is the url the JSON we're displaying comes from
   */
  apiEndpoint: `${_.result(window, 'SiteInfo.homeUrl', '')}/wp-json/wp/v2/${postType}`,


  /**
   * mapRawJSONToObject is used to map from the raw API JSON to a cleaner
   * version used as props for the component specified in itemView
   */
  mapRawJSONToObject: p => {
    let ret = {
      id: p.id,
      key: p.id,
      permalink: p.link,
      title: p.title.rendered,
      excerpt: p.excerpt.rendered,
      featuredImage: _.result(p, '_embedded.wp:featuredmedia[0].media_details.sizes.full.source_url'),
      terms: []
    };

    let terms = _.flattenDeep(_.result(p, '_embedded.wp:term'));
    let taxonomies = Config.filterTaxonomies.map(f => f.key);
    let type = terms.filter(term => term.taxonomy === 'category');
    ret.type = _.result(type, '[0].name');

    taxonomies.map(taxonomy => {
      let taxonomyTerms = terms.filter(term => term.taxonomy === taxonomy);
      ret[taxonomy] = taxonomyTerms;
      if(taxonomyTerms){
        ret.terms = [...ret.terms, ...taxonomyTerms];
      }
    });

    return ret;
    },

  getAPIEndpoint: state => {
    let val = '';
    let queryString = '';
    let queryArray = [
      { key: "_embed", value: 1 },
      { key: "per_page", value: Config.pageLength },
      { key: 'page', value: state.filter.page }
    ];

    if(state.filter.text){
      queryArray.push({ key: 'search', value: state.filter.text });
    }

    for(const filterKey of Object.keys(state.filter)){
      val = state.filter[filterKey];
      if(!val){
        continue;
      }

      let filterVals = [];

      switch(filterKey){
        case 'text':
        case 'page':
        case 'totalPages':
          break;
        case 'category':
          filterVals = val.map(f => ({ key: 'categories[]', value: f.id }));
          queryArray = queryArray.concat(filterVals);
          break;
        case 'post_tag':
          filterVals = val.map(f => ({ key: 'tags[]', value: f.id }));
          queryArray = queryArray.concat(filterVals);
          break;
        default:
          filterVals = val.map(f => ({ key: `${filterKey}[]`, value: f.id }));
          queryArray = queryArray.concat(filterVals);
      }
    }

    queryString = queryArray.map(q => `${encodeURIComponent(q.key)}=${encodeURIComponent(q.value)}`).join('&');
    return Config.apiEndpoint + '?' + queryString;
  }
}


export default Config;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/config.js